import './footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <p>© 2025 Journaly by Ravid</p>
      <p>
        <a
          className="coffee"
          target="_blank"
          href="https://buymeacoffee.com/ravidef"
        >
          Buy me a Coffee
        </a>
      </p>
    </footer>
  );
}
